export class SQASubCode
{
    sqaSubCodeId: number;
    sqaSubCode: string;
    sqaSubDescription: string;
    displaySortOrder: number;
    isActiveFlag: number;
    isCustomFlag: number;
}